module.exports = __webpack_public_path__ + "img/img24.a717e59d.svg";